<h1 class="screen-reader-only" [innerHTML]="copy"></h1>
<div class="c04-opening-screen" #openingScreenRef>
  <h1 class="intro-copy" aria-live="assertive" [innerHTML]="copy"></h1>
</div>
